<template>
    <Paper class="delegate-letter">
        <MPanel
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :pageID="pageID"
            :searchId="searchId"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @detail-btn="viewDetail">
            <div slot="table-module-btn">
                <div class="icon-button">
                    <el-button
                        v-has="'/driverDelegateLetter-10'"
                        size="mini"
                        class="bigData-btn-all-desensitization"
                        :icon="isSensitive ? 'icon-show' : 'icon-hidden'"
                        @click="handleSensitive"
                    ></el-button>
                    <el-tooltip class="item" content="导出" placement="bottom">
                        <el-button
                            class="bigData-btn-export"
                            size="mini"
                            icon="el-icon-download"
                            :loading="exportLoading"
                            @click="handleExport"></el-button>
                    </el-tooltip>
                </div>
            </div>
            <div slot="page-module-btn">
                <el-button
                    :loading="btnLoading"
                    :disabled="!checkedData.length || checkedData.length > 20"
                    class="bigData-btn-add"
                    type="primary"
                    @click="sign">
                    发起供应商签署
                </el-button>
            </div>
        </MPanel>

        <Detail ref="detail" :visible.sync="detailVisible" />
    </Paper>
</template>
<script>
import dayjs from 'dayjs'
import MPanel from '@/components/supplierPanel'
import Paper from '@/components/core/paper/Paper'
import { dictWithUrl } from '@/components/lots/api'
import config from './config.js'
import {
    supplierDelegateManageRecordPage,
    supplierDelegateManageRecordPush,
    exportSupplierDelegateManageRecord,
} from '../../../../../api/driverDelegateLetter.js'
import { getSensitiveVal, handleTableDataSensitive } from '../../../../../utils/common.js';
import Detail from './detail.vue'
export default {
    name: 'driverDelegateLetter',
    components: { Paper, MPanel, Detail },
    data() {
        return {
            totalData: [],
            pageTotal: 0,
            loading: false,
            pageID: 'delegate-letter-20251025',
            searchId: 'delegate-letter-sd',
            pageNo: 1,
            searchTerm: { timeRange: [] },
            pageSize: 10,
            checkedData: [],
            exportLoading: false,
            dictData: {},
            rowData: {},
            detailVisible: false,
            btnLoading: false,
            isSensitive: true, // 列表数据是否脱敏
        }
    },
    computed: {
        config() {
            const idx = config.searchList.searchTxt.findIndex(v => v.name === '供应商')
            if (this.$store.state.supplier && idx > -1) {
                config.searchList.searchTxt.splice(idx, 1)
                //lsp端需要更换司机筛选弹窗接口
                const driverIdx = config.searchList.searchTxt.findIndex(v => v.name === '司机')
                config.searchList.searchTxt[driverIdx].advanceUrl = '/supplier/supplierDriverInfo/workbenchDrivers'
                return config
            } else {
                return config
            }
        },
    },
    methods: {
        sign() {
            if (this.checkedData.some(v => this.checkedData[0].supplierCode !== v.supplierCode)) {
                return this.$message.warning('仅支持同个供应商发起批量签署，请重新选择')
            }
            if (this.checkedData.some(v => v.supplierPushStatus !== '2')) {
                return this.$message.warning('供应商签署状态为待发起的，才支持发起供应商签署，请重新选择')
            }
            this.btnLoading = true
            supplierDelegateManageRecordPush({ ids: this.checkedData.map(v => v.id) })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('已发起供应商签署')
                        this.loadData()
                    }
                })
                .finally(() => {
                    this.btnLoading = false
                })
        },
        viewDetail(v) {
            this.detailVisible = true
            this.$refs['detail'].getList(v.contractNo)
        },
        selectChange(data) {
            if (data && data.length > 0) {
                this.checkedData = data
            } else {
                this.checkedData = []
            }
        },
        searchChange(data) {
            this.pageNo = 1
            const params = this.getParams(data)
            const regx = /^[0-9][0-9]*$/
            if (params.stamperMobile && !regx.test(params.stamperMobile)) {
                return this.$message.warning('签署手机号码仅可输入数字')
            }
            if(!params.signNumber && !params.signFileNo && !params.startTime){
                return this.$message.warning('签署批次号、签署文件编号、时间范围不能同时为空')
            }
            if (params.startTime && Math.abs(dayjs(params.startTime).diff(params.endTime, 'day')) > 60) {
                return this.$message.warning('时间范围不能大于2个月')
            }
            this.searchTerm = data
            this.loadData()
        },
        pageChange(data) {
            this.isSensitive = true
            this.pageNo = data
            this.loadData()
        },
        sizeChange(data) {
            this.isSensitive = true
            this.pageSize = data
            this.loadData()
        },
        // 处理请求参数
        getParams(p) {
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...p,
            }
            if (this.$store.state.supplier) {
                params.supplierCode = this.$store.state.supplier.supplierCode
            }
            if (params.timeRange) {
                params.startTime = dayjs(params.timeRange[0]).format('YYYY-MM-DD HH:mm:ss')
                params.endTime = dayjs(params.timeRange[1]).format('YYYY-MM-DD HH:mm:ss')
                delete params.timeRange
            }
            if(params.driverPushStatusList === ''){
                params.driverPushStatusList = []
            }
            if(params.supplierPushStatusList === ''){
                params.supplierPushStatusList = []
            }
            // for (const key in params) {
            //     if (Array.isArray(params[key])) {
            //         params[key] = params[key].join(',')
            //     }
            // }
            return params
        },
        loadData() {
            const params = this.getParams(this.searchTerm)
            this.loading = true
            supplierDelegateManageRecordPage(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.pageTotal = res.data.totalCount || 0
                        res.data.list.forEach(v => {
                            v.tagList_ = (v.tagList || []).map(v => v.tagName)
                            if (v.driverDeleteFlag === 1) {
                                v.driverName = getSensitiveVal(v.driverName, 'cname')
                                v._driverNameTags = '已注销'
                                v.phoneNo = getSensitiveVal(v.phoneNo, 'phone')
                                v._phoneNoTags = '已注销'
                            }
                        })
                        this.totalData = res.data.list
                        this.selectChange()
                        this.onHandleTableDataSensitive()
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 导出
        handleExport() {
            this.exportLoading = true
            const params = this.getParams(this.searchTerm)
            delete params.pageNo
            delete params.pageSize
            exportSupplierDelegateManageRecord(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        const a = document.createElement('a');
                        a.href = res.data.downUrl;
                        a.download = res.data.localFileName;
                        a.target = '_blank';
                        a.click();
                        this.$message.success('下载成功');
                    }
                })
                .finally(() => {
                    this.exportLoading = false
                })
        },
        initTimeDefault() {
            let timeRange = [
                dayjs().subtract(6, 'day').format('YYYY-MM-DD 00:00:00'),
                dayjs().format('YYYY-MM-DD 23:59:59'),
            ]
            this.$refs.tablePage.$refs.searchList.searchData.timeRange = timeRange
            this.searchTerm.timeRange = timeRange

            if (this.$store.state.supplier) {
                // LSP
                if (this.$route.query.supplierPushStatusList !== undefined) {
                    const supplierPushStatusList = this.$route.query.supplierPushStatusList;
                    if (supplierPushStatusList === '0') {
                        this.$refs.tablePage.$refs.searchList.searchData.supplierPushStatusList = ['0'];
                        this.searchTerm.supplierPushStatusList = ['0'];
                    }

                    if (this.$route.query.from === 'homePage') {
                        const timeRangeMonth = [
                            dayjs().subtract(1, 'month').format('YYYY-MM-DD 00:00:00'),
                            dayjs().format('YYYY-MM-DD 23:59:59')
                        ];
                        this.$refs.tablePage.$refs.searchList.searchData.timeRange = timeRangeMonth;
                        this.searchTerm.timeRange = timeRangeMonth;
                    }

                    this.loadData();
                }
            }
        },
        // 信息脱敏
        onHandleTableDataSensitive(setFlag = false){
            handleTableDataSensitive(this, 'isSensitive', 'totalData', [
                {
                    dataKey: 'phoneNo',
                    showKey: '_phoneNo',
                    type: 'phone'
                },
            ], setFlag)
        },
        handleSensitive() {
            this.onHandleTableDataSensitive(true)
        },
    },
    activated() {
        if (this.$store.state.supplier) {
            // LSP
            if (this.$route.query.supplierPushStatusList !== undefined) {
                this.initTimeDefault();
            }
        }
    },
    mounted() {
        this.initTimeDefault()
        // dictWithUrl(
        // ).then(res => {
        //     if (res && +res.code === 0) {
        //         this.dictData = res.data
        // this.loadData()
        //     }
        // })
    },
}
</script>
<style lang="less">
.delegate-letter {
    flex: 1;
    overflow: hidden;
    .select-btn-box {
        margin-bottom: 10px;
    }

    #mPane3 {
        height: 100%;
        display: flex;
        flex-direction: column;
        .otp-table {
            flex: 1;
        }
        .el-table {
            min-height: initial;
        }
        // min-height: calc(100vh - 206px);
    }

    .cell-extra-tag span {
        color: #7f7f7f;
    }
}
</style>